import { ESlotStatus } from '../../../1_shared/config/enums/ESlotStatus';

export const PaymentStatus: Record<string, string> = {
  [ESlotStatus.Approved]: 'Оплачено',
  [ESlotStatus.WaitingForPay]: 'Не оплачено',
  [ESlotStatus.Free]: 'Оплата не требуется',
};
